/**
 * Static branch list used only when the catalog API cannot be reached.
 *
 * The catalog is the source of truth. This exists so a network failure degrades
 * to a stale-but-usable list instead of an empty screen — and every surface
 * that falls back to it says so, because a silent stale list is how someone
 * files an order against a branch that no longer exists.
 */
export type FallbackBranch = {
  code: string;
  name: string;
  shortLabel: string;
  /** Root-level group code the branch sits under; the region key. */
  region: string;
};

export const FALLBACK_BRANCHES: FallbackBranch[] = [
  { code: "sg_32", name: "SG - ĐƯỜNG 3/2", shortLabel: "ĐƯỜNG 3/2", region: "sg" },
  { code: "sg_lvs", name: "SG - LÊ VĂN SỸ", shortLabel: "LÊ VĂN SỸ", region: "sg" },
  { code: "hn_01", name: "HN - CƠ SỞ 1", shortLabel: "CƠ SỞ 1", region: "hn" },
  { code: "hn_dl", name: "HN - NGUYỄN KHANG", shortLabel: "NGUYỄN KHANG - HÀ NỘI", region: "hn" },
  { code: "ext_hn", name: "NGOÀI STUDIO HÀ NỘI", shortLabel: "NGOÀI STUDIO HN", region: "hn" },
  { code: "ext_sg", name: "NGOÀI STUDIO SG", shortLabel: "NGOÀI STUDIO SG", region: "sg" },
];

export const FALLBACK_REGIONS = [
  { id: "hn", label: "Hà Nội" },
  { id: "sg", label: "TP.HCM" },
];
